// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"389":"e89a8422f2bb04a76381","524":"9ecda3070cfecb3e44c8"}[chunkId] + ".css";
};